import { LandsbankinnIcon24, Row } from '@landsbankinn/ui-kit';

export const HEIGHT = '90';
export const MAX_WIDTH = '780';

export function SimpleHeader() {
  return (
    <Row
      as="header"
      height={HEIGHT}
      borderBottom="thin"
      marginHorizontal="auto"
      paddingVertical="36"
      width="100%"
      mainAxisAlignment="center"
    >
      <Row
        paddingHorizontal="20"
        grow="1"
        maxWidth={MAX_WIDTH}
        mainAxisAlignment="start"
        crossAxisAlignment="center"
      >
        <LandsbankinnIcon24 size="36" color="blue font" />
      </Row>
    </Row>
  );
}
